var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5736 2.34817L11 0L8.42638 2.34817L4.9918 1.76417L4.09624 5.13097L0.891154 6.49656L1.958 9.81307L0 12.6947L2.69053 14.9079L2.60127 18.3907L6.06126 18.798L7.86907 21.7761L11 20.2481L14.1309 21.7761L15.9387 18.798L19.3987 18.3907L19.3095 14.9079L22 12.6947L20.042 9.81307L21.1088 6.49656L17.9038 5.13097L17.0082 1.76417L13.5736 2.34817ZM15.3561 7.57428C15.6851 7.24586 16.1786 7.24586 16.5076 7.57428C16.8366 7.9027 16.8366 8.39532 16.5076 8.72374L9.76309 15.4563C9.59859 15.6205 9.43408 15.7026 9.18733 15.7026C8.94058 15.7026 8.77608 15.6205 8.61158 15.4563L5.48605 12.3363C5.15705 12.0079 5.15705 11.5153 5.48605 11.1869C5.81505 10.8584 6.30856 10.8584 6.63756 11.1869L9.18733 13.7321L15.3561 7.57428Z",
    fill: "#20639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.aee61216023c9c3e069c711c6e9bf7b8.svg";
export { ForwardRef as ReactComponent };